import React from 'react';
import { shape, string, array } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from '../Button';
import { useStyle } from '../../classify';
import defaultClasses from './filterModalOpenButton.module.css';
import { useFilterModal } from '@magento/peregrine/lib/talons/FilterModal';

var FilterModalOpenButton = function FilterModalOpenButton(props) {
  var filters = props.filters,
      propsClasses = props.classes;
  var classes = useStyle(defaultClasses, propsClasses);

  var _useFilterModal = useFilterModal({
    filters: filters
  }),
      handleOpen = _useFilterModal.handleOpen;

  return React.createElement(Button, {
    priority: 'low',
    classes: {
      root_lowPriority: classes.filterButton
    },
    onClick: handleOpen,
    type: "button",
    "aria-live": "polite",
    "aria-busy": "false"
  }, React.createElement(FormattedMessage, {
    id: 'productList.filter',
    defaultMessage: 'Filter'
  }));
};

export default FilterModalOpenButton;
FilterModalOpenButton.propTypes = {
  classes: shape({
    filterButton: string
  }),
  filters: array
};